// extracted by mini-css-extract-plugin
module.exports = {"dataColumn":"_2ZVRDaQ","dataRow":"_17_55UW","dataContainer":"_3IeLNKZ"};